import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';

import { useCollectionUrlGenerator } from '../../hooks/useUrlGenerator';
import getRatio from '../../lib/getRatio';
import normalizeCardTheme from '../../lib/normalizeCardTheme';

import CollectionImage from '../partials/CollectionImage';
import CardTitle from '../typography/CardTitle';
import OverCard from './OverCard';

import styles from '../../styles/cards/collection-over-card.module.css';

interface CollectionOverCardProps extends Partial<Omit<CollectionSnippet, 'theme'>> {
    theme?: CardTheme | LegacyCardTheme | null;
    size?: CardSize;
    ratio?: CardRatio;
    width?: number;
    placeholder?: boolean;
    withoutText?: boolean;
    className?: string | null;
}

function CollectionOverCard({
    type = null,
    slug = null,
    title = null,
    image = null,
    theme: providedTheme = null,
    size = null,
    ratio = null,
    width = 120,
    placeholder = false,
    withoutText = false,
    className = null,
}: CollectionOverCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const collectionUrl = useCollectionUrlGenerator();
    const thumbnailRatio = getRatio(ratio, 1);

    return (
        <OverCard
            theme={theme || 'none'}
            size={size || 'default'}
            href={
                collectionUrl({
                    type,
                    slug,
                }) || '#'
            }
            thumbnail={
                <CollectionImage
                    width={width}
                    height={width / thumbnailRatio}
                    media={image}
                    className={styles.thumbnail}
                    withPlaceholder={placeholder}
                    withoutSize
                />
            }
            thumbnailRatio={thumbnailRatio}
            className={classNames([
                styles.container,
                {
                    [styles.withoutText]: withoutText,
                },
                styles[camelCase(ratio as string)],
                className,
            ])}
            thumbnailClassName={styles.thumbnailContainer}
            labelClassName={styles.label}
            innerClassName={styles.inner}
        >
            {!withoutText ? (
                <CardTitle className={styles.title} placeholder={placeholder}>
                    {title}
                </CardTitle>
            ) : null}
        </OverCard>
    );
}

export default CollectionOverCard;
